module.exports = __webpack_public_path__ + "static/media/luypaerts1.4911e9fe.jpg";